module.exports = __webpack_public_path__ + "static/media/as3cr128.867a3efd.png";